import { cardHours, type TrayCard, type Week } from '../_lib/auto-place'
import type { CurriculumPreset, CurriculumState } from './contracts'

const deepEqual = (left: unknown, right: unknown): boolean => {
  if (Object.is(left, right)) return true
  if (Array.isArray(left) || Array.isArray(right)) {
    return (
      Array.isArray(left) &&
      Array.isArray(right) &&
      left.length === right.length &&
      left.every((value, index) => deepEqual(value, right[index]))
    )
  }
  if (
    typeof left !== 'object' ||
    left === null ||
    typeof right !== 'object' ||
    right === null
  ) {
    return false
  }
  const leftRecord = left as Record<string, unknown>
  const rightRecord = right as Record<string, unknown>
  const leftKeys = Object.keys(leftRecord).sort()
  const rightKeys = Object.keys(rightRecord).sort()
  return (
    leftKeys.length === rightKeys.length &&
    leftKeys.every(
      (key, index) =>
        key === rightKeys[index] &&
        deepEqual(leftRecord[key], rightRecord[key]),
    )
  )
}

export const activePreset = (
  state: CurriculumState,
  presets: CurriculumPreset[],
): string | null =>
  presets.find(
    (preset) =>
      preset.typeFilter === state.typeFilter &&
      deepEqual(preset.filters, state.filters) &&
      deepEqual(preset.sorts, state.sorts),
  )?.id ?? null

export const placingCard = (state: CurriculumState): TrayCard | null =>
  state.tray.find((card) => card.id === state.placingId) ?? null

export const dayUsedHours = (
  weeks: Week[],
  weekIdx: number,
  dayIdx: number,
): number =>
  weeks[weekIdx]?.days[dayIdx]?.cards.reduce(
    (total, card) => total + cardHours(card),
    0,
  ) ?? 0
